import { ServiceCustomer } from '@/service/customer/serviceCustomer'
import { ServiceSpecialists } from '@/service/specialists/serviceSpecialists'

const serviceCustomer = new ServiceCustomer()
const serviceSpecialists = new ServiceSpecialists()
export default {
  namespaced: true,
  state: {
    loading: false,
    profile: {
      personalData: {
        fullName: '',
        birthDate: '',
        cpf: '',
        special_document_type: '',
        special_document_number: '',
      },
      contactDetails: {
        email: '',
        cellphone: '',
        phone: '',
        contactPreference: '',
      },
      settingDetails: {
        stopwatch: null,
        summary: '',
      },
      several: {
        nickname: '',
        maritalStatus: '',
        gender: '',
      },
      address: {
        zipCode: '',
        address: '',
        number: '',
        complement: '',
        district: '',
        city: '',
        state: '',
      },
      cards: [],
      bankAccount: {
        bank_code: '',
        agencia: '',
        agencia_dv: '',
        conta: '',
        conta_dv: '',
        type_account: '',
        document_number: '',
        name_account: '',
        bank_account_id: '',
        recipient_id: '',
      },
      creditBalance: {
        totalBalance: 0,
        credits: []
      }
    },
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_PERSONAL_DATA(state, payload) {
      state.profile.personalData = payload
    },
    SET_CONTACT_DETAILS(state, payload) {
      state.profile.contactDetails = payload
    },
    SET_SETTING_DETAILS(state, payload) {
      state.profile.settingDetails = payload
    },
    SET_SEVERAL(state, payload) {
      state.profile.several = payload
    },
    SET_ADDRESS(state, payload) {
      state.profile.address = payload
    },
    SET_CARDS(state, payload) {
      state.profile.cards = payload
    },

    SET_BANK_ACCOUNT(state, payload) {
      state.profile.bankAccount = payload
    },
    CLEAR_BANK_ACCOUNT(state) {
      state.profile.bankAccount = {
        bank_code: '',
        agencia: '',
        agencia_dv: '',
        conta: '',
        conta_dv: '',
        type_account: '',
        document_number: '',
        name_account: '',
        bank_account_id: '',
        recipient_id: '',
      }
    },

    SET_CREDIT_BALANCE(state, payload) {
      state.profile.creditBalance = payload
    }
  },
  getters: {
    loading(state) {
      return state.loading
    },
    gettersPersonalData(state) {
      return state.profile.personalData
    },
    gettersContactDetails(state) {
      return state.profile.contactDetails
    },
    gettersSettingDetails(state) {
      return state.profile.settingDetails
    },
    gettersSeveral(state) {
      return state.profile.several
    },
    gettersAddress(state) {
      return state.profile.address
    },
    gettersCards(state) {
      return state.profile.cards
    },
    gettersBankAccount(state) {
      return state.profile.bankAccount
    },
    gettersCreditBalance(state) {
      return state.profile.creditBalance
    }
  },
  actions: {
    async getCustomersByUUID({ commit }) {
      commit('SET_LOADING', true)
      const resultCustomer = await serviceCustomer.getCustomersByUuId()
      commit('SET_PERSONAL_DATA', resultCustomer.customer.personalData)
      commit('SET_CONTACT_DETAILS', resultCustomer.customer.contactDetails)
      commit('SET_SEVERAL', resultCustomer.customer.several)
      commit('SET_ADDRESS', resultCustomer.customer.address)
      commit('SET_CARDS', resultCustomer.customer.cards)
      commit('SET_CREDIT_BALANCE', resultCustomer.customer.creditBalance)
      commit('SET_LOADING', false)
    },
    async updateCustomer({ commit }, data) {
      commit('SET_LOADING', true)
      await serviceCustomer.updateCustomers(data)

      commit('SET_LOADING', false)
    },

    // specialista
    async getSpecialistsByUUUID({ commit }, uuid) {
      commit('SET_LOADING', true)
      const resultSpecialist = await serviceSpecialists.getSpecialistsByUuId(uuid)
      commit('SET_PERSONAL_DATA', resultSpecialist.specialist.personalData)
      commit('SET_CONTACT_DETAILS', resultSpecialist.specialist.contactDetails)
      commit('SET_SETTING_DETAILS', resultSpecialist.specialist.settings)
      commit('SET_SEVERAL', resultSpecialist.specialist.several)
      commit('SET_BANK_ACCOUNT', resultSpecialist.specialist.bankAccount)
      commit('SET_LOADING', false)
    },

    async updateSpecialist({ commit }, data) {
      commit('SET_LOADING', true)
      await serviceSpecialists.updateSpecialists(data)
      commit('SET_LOADING', false)
    },
  },
}
